var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-avatar',{class:_vm.classes,attrs:{"icon":_vm.icon,"src":_vm.source,"shape":"circle"}})}
var staticRenderFns = []

export { render, staticRenderFns }